import {connect} from 'react-redux'
import {Link} from 'react-router'
import {Map} from 'immutable'
import classnames from 'classnames'
import PropTypes from 'prop-types'
import React from 'react'

import LoggedInMenu from './LoggedInMenu'
import Container from '../../../../lib/Container'
import Dev from '../../../../dev_only'
import FirmActions from '../../actions/FirmActions'
import OrganizationCobrandingHeaderLogo from '../../../../shared_components/header/OrganizationCobrandingHeaderLogo'

import {
  useOrganizationCobranding
} from '../../../../shared_components/OrganizationCobrandingContext'

import {
  hasOrganizationCobranding
} from '../../../../lib/cobrandingTools'

import {proBrandingResolved, proBrandName, usesFuneralHomeBranding} from '../../lib/firmTools'
import {findRawResourceById} from '../../../../lib/plan_data/userData'

import SessionStore from '../../../../auth/src/stores/SessionStore'
import storePrototype from '../../../../shared_components/StorePrototype'

import '../../../../shared_components/header/header.scss'
import './header.scss'

export const ProHeaderWithOrganizationCobranding = ({currentUser, firm, sessionInitialized}) => {
  const organizationCobranding = useOrganizationCobranding()

  return (
    <Header
      currentUser={currentUser}
      firm={firm}
      organizationCobranding={organizationCobranding}
      sessionInitialized={sessionInitialized}
    />
  )
}

ProHeaderWithOrganizationCobranding.propTypes = {
  currentUser: PropTypes.object,
  firm: PropTypes.instanceOf(Map),
  sessionInitialized: PropTypes.bool
}

const mapStateToProps = (state, ownProps) => ({
  firm: findRawResourceById({
    rawResource: state.api.firms,
    id: ownProps.currentUser?.firm
  })
})

const ConnectedProHeader = connect(mapStateToProps)(ProHeaderWithOrganizationCobranding)

export default class ProHeaderController extends React.Component {
  constructor(props) {
    super(props)
    this.state = {
      data: this.currentUser() || {},
      sessionInitialized: SessionStore.initialized()
    }

    this.onUpdate = this.onUpdate.bind(this)
  }

  componentDidMount() { SessionStore.addChangeListener(this.onUpdate) }

  onUpdate() {
    this.setState({
      data: this.currentUser() || {},
      sessionInitialized: SessionStore.initialized()
    })
  }

  componentWillUnmount() { SessionStore.removeChangeListener(this.onUpdate) }

  currentUser() { return SessionStore.getState().currentUser }

  render() {
    return (
      <ConnectedProHeader
        currentUser={this.state.data}
        sessionInitialized={this.state.sessionInitialized}
      />
    )
  }
}

export class Header extends React.Component {
  constructor() {
    super()

    this.registerActionAndStores()
    this.store = Container.getStore('firmUsers')
    this.firmConfigStore = Container.getStore('firmConfig')
    this.action = Container.getAction('firm_users')
    this.firmConfigAction = Container.getAction('firm_config')

    this.state = {
      firmUsers: this.listFirmUsers(),
      firmConfig: this.firmConfigStore.getState().data
    }

    this.onFirmConfigUpdate = this.onFirmConfigUpdate.bind(this)
    this.onUpdate = this.onUpdate.bind(this)
  }

  registerActionAndStores() {
    Container.registerAction('firm_users', FirmActions)
    Container.registerStore('firmUsers', storePrototype(FirmActions.Types.GOT_FIRM_USERS))
    Container.registerStore('firmConfig', storePrototype(FirmActions.Types.GOT_FIRM_CONFIG))
  }

  componentDidMount() {
    this.firmConfigStore.addChangeListener(this.onFirmConfigUpdate)
    this.store.addChangeListener(this.onUpdate)
    if (!this.state.firmUsers.length && this.props.currentUser && this.props.currentUser.firm) {
      this.action.fetchFirmUsers(this.props.currentUser.firm)
      FirmActions.fetchFirmConfig(this.props.currentUser.firm)
    }
  }

  UNSAFE_componentWillReceiveProps(nextProps) {
    const currentUser = nextProps.currentUser
    /**
     * We don't want account manager to fetch the firm users or config here so it doesn't
     * overwrite the firm_config later in the app when it's fetching for individual firms. - TK
     */
    if (currentUser && !currentUser.account_manager && currentUser.firm && !this.state.firmUsers.length) {
      this.action.fetchFirmUsers(currentUser.firm)
      FirmActions.fetchFirmConfig(currentUser.firm)
    }
  }

  onUpdate() {
    this.setState({firmUsers: this.listFirmUsers()})
  }

  onFirmConfigUpdate() {
    this.setState({
      firmConfig: this.firmConfigStore.getState().data
    })
  }

  componentWillUnmount() {
    this.store.removeChangeListener(this.onUpdate)
    this.firmConfigStore.removeChangeListener(this.onFirmConfigUpdate)
  }

  listFirmUsers() {
    const storeState = this.store.getState().data
    return storeState.advisors && storeState.advisors.seats ? storeState.advisors.seats : []
  }

  usesFuneralHomeBranding() {
    return usesFuneralHomeBranding({
      isConcierge: this.props.currentUser && this.props.currentUser.quarterback,
      firm: this.props.firm
    })
  }

  brandingResolved() {
    return proBrandingResolved({
      currentUser: this.props.currentUser,
      firm: this.props.firm,
      sessionInitialized: this.props.sessionInitialized
    })
  }

  brandingClassName() {
    return classnames('branding', {
      'funeral-home': this.usesFuneralHomeBranding(),
      pending: !this.brandingResolved(),
      'with-organization-cobranding': hasOrganizationCobranding(this.props.organizationCobranding)
    })
  }

  brandingText() { return this.brandingResolved() ? proBrandName(this.usesFuneralHomeBranding()) : '' }

  render() {
    const currentUser = this.props.currentUser

    if (currentUser && Object.keys(currentUser).length > 0) {
      return (
        <header className='pro-header'>
          <Dev.Title title={this.props.currentUser.id} />
          <nav>
            <div className='header-content row-wrapper-sb'>
              <div className='logo-container'>
                {hasOrganizationCobranding(this.props.organizationCobranding) &&
                <OrganizationCobrandingHeaderLogo
                  organizationCobranding={this.props.organizationCobranding}
                />}
                <Link
                  activeClassName='active'
                  className={this.brandingClassName()}
                  to='/pro'>
                  {this.brandingText()}
                </Link>
              </div>
              <LoggedInMenu currentUser={currentUser} advisors={this.state.firmUsers} professionalDesignation={this.state.firmConfig.professional_designation} />
            </div>
          </nav>
        </header>
      )
    } else {
      return (
        <header className='pro-header'>
          <nav>
            <div className='header-content row-wrapper-sb'>
              <div className='logo-container'>
                {hasOrganizationCobranding(this.props.organizationCobranding) &&
                <OrganizationCobrandingHeaderLogo
                  organizationCobranding={this.props.organizationCobranding}
                />}
                <span className={this.brandingClassName()}>
                  {this.brandingText()}
                </span>
              </div>
            </div>
          </nav>
        </header>
      )
    }
  }
}

Header.defaultProps = {
  currentUser: {},
  firm: Map(),
  organizationCobranding: null,
  sessionInitialized: false
}

Header.propTypes = {
  currentUser: PropTypes.object,
  firm: PropTypes.instanceOf(Map),
  organizationCobranding: PropTypes.shape({
    enabled: PropTypes.bool,
    organizationLogoUrl: PropTypes.string,
    type: PropTypes.string
  }),
  sessionInitialized: PropTypes.bool
}
